import React, { useMemo } from 'react';
import { DataTable } from '@components/organisms/Documents/components/DataTable';
import { DelegatedTaskCost } from '@models/lineItem.model';
import { useTranslation } from '@hooks/useTranslation';

interface DelegatedTasksTabProps {
  delegatedTaskCosts: DelegatedTaskCost[];
}

const formatCurrency = (value: number) => {
  return `$ ${value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

export const DelegatedTasksTab: React.FC<DelegatedTasksTabProps> = ({
  delegatedTaskCosts,
}) => {
  const tProjectComponents = useTranslation('projectComponents');
  const t = tProjectComponents.delegatedTasksTab;
  const columns = useMemo(
    () => [
      {
        key: 'taskName',
        label: t.colTaskName,
        className: 'col-span-1',
        render: (v: string) => v || '-',
      },
      {
        key: 'organizationName',
        label: t.colDelegatedTo,
        className: 'col-span-1',
        render: (v: string) => v || '-',
      },
      {
        key: 'budget',
        label: t.colAcceptedBudget,
        className: 'col-span-1',
        render: (v: number) => formatCurrency(v || 0),
      },
    ],
    [t],
  );

  const totalDelegated = delegatedTaskCosts.reduce(
    (sum, d) => sum + (d.budget || 0),
    0,
  );

  return (
    <div>
      <DataTable
        height={500}
        loading={false}
        columns={columns}
        data={delegatedTaskCosts}
        compact
        emptyMessage={t.emptyMessage}
      />

      <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-md mt-2">
        <div className="flex flex-col gap-0.5">
          <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wide">
            {t.totalDelegatedCost}
          </p>
          <p className="text-sm font-bold text-gray-900">
            {formatCurrency(totalDelegated)}
          </p>
        </div>
      </div>
    </div>
  );
};
